import PropTypes from 'prop-types';
import Tick from '../../assets/icons/Tick.svg?react';
import styles from './Checkbox.module.scss';

const Checkbox = ({
  checked = false,
  onChange,
  label,
  value,
  name,
  size = 'md',
  disabled = false,
  className = '',
  variant = 'circular' // 'circular' or 'square'
}) => {
  const handleChange = () => {
    if (!disabled && onChange) {
      onChange(value);
    }
  };

  const classes = [
    styles.checkbox,
    styles[size],
    styles[variant],
    checked ? styles.checked : '',
    disabled ? styles.disabled : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={classes}>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={styles.input}
      />
      <div className={styles.indicator}>
        {checked && (
          <Tick
            width={size === 'sm' ? 12 : size === 'lg' ? 20 : 16}
            height={size === 'sm' ? 12 : size === 'lg' ? 20 : 16}
          />
        )}
      </div>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  name: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['circular', 'square'])
};

export default Checkbox;
